if (!customElements.get("custom-select")) {
  class t extends HTMLElement {
    constructor() {
      super(), this.button = this.querySelector(".custom-select__btn"), this.listbox = this
        .querySelector(".custom-select__listbox"), this.selectedOption = this.querySelector(
          '[aria-selected="true"]'), this.selectedOption || (this.selectedOption = this.listbox &&
        this.listbox.firstElementChild), this.button && this.listbox && this.selectedOption && this
        .setButtonWidth(), this.button && this.listbox && this.selectedOption && window
        .initLazyScript(this, this.init.bind(this))
    }
    init() {
      if (!this.button || !this.listbox || !this.selectedOption) return;
      this.options = this.querySelectorAll(".custom-select__option"), this.nativeSelect = document
        .getElementById(`${this.id}-native`), this.swatches = "swatch" in this.options[this
          .options.length - 1].dataset, this.focusedClass = "is-focused", this.searchString = "",
        this.listboxOpen = !1, this.selectedOption = this.querySelector('[aria-selected="true"]'),
        this.selectedOption || (this.selectedOption = this.listbox.firstElementChild), this
        .addEventListener("keydown", this.handleKeydown.bind(this)), this.button.addEventListener(
          "mousedown", this.handleMousedown.bind(this))
    }
    static getNextVisibleSibling(t) {
      let e = t.nextElementSibling;
      for (; e;) {
        if ("none" !== e.style.display) return e;
        e = e.nextElementSibling
      }
      return null
    }
    static getPreviousVisibleSibling(t) {
      let e = t.previousElementSibling;
      for (; e;) {
        if ("none" !== e.style.display) return e;
        e = e.previousElementSibling
      }
      return null
    }
    addListboxOpenListeners() {
      this.mouseoverHandler = this.handleMouseover.bind(this), this.mouseleaveHandler = this
        .handleMouseleave.bind(this), this.clickHandler = this.handleClick.bind(this), this
        .blurHandler = this.handleBlur.bind(this), this.listbox.addEventListener("mouseover", this
          .mouseoverHandler), this.listbox.addEventListener("mouseleave", this.mouseleaveHandler),
        this.listbox.addEventListener("click", this.clickHandler), this.listbox.addEventListener(
          "blur", this.blurHandler)
    }
    removeListboxOpenListeners() {
      this.listbox.removeEventListener("mouseover", this.mouseoverHandler), this.listbox
        .removeEventListener("mouseleave", this.mouseleaveHandler), this.listbox
        .removeEventListener("click", this.clickHandler), this.listbox.removeEventListener("blur",
          this.blurHandler)
    }
    handleKeydown(t) {
      this.listboxOpen ? this.handleKeyboardNav(t) : ("ArrowUp" === t.key || "ArrowDown" === t
        .key || " " === t.key) && (t.preventDefault(), this.showListbox())
    }
    handleMousedown(t) {
      this.listboxOpen || 0 !== t.button || this.showListbox()
    }
    handleMouseover(t) {
      t.target.matches("li") && this.focusOption(t.target)
    }
    handleMouseleave() {
      this.focusOption(this.selectedOption)
    }
    handleClick(t) {
      "LI" === t.target.tagName && this.selectOption(t.target)
    }
    handleBlur() {
      this.listboxOpen && this.hideListbox()
    }
    handleKeyboardNav(e) {
      let s;
      switch ("Tab" === e.key && e.preventDefault(), e.key) {
        case "ArrowUp":
        case "ArrowDown":
          e.preventDefault(), (s = "ArrowUp" === e.key ? t.getPreviousVisibleSibling(this
              .focusedOption) : t.getNextVisibleSibling(this.focusedOption)) && !s.classList
            .contains("is-disabled") && this.focusOption(s);
          break;
        case "Enter":
        case " ":
          e.preventDefault(), this.selectOption(this.focusedOption);
          break;
        case "Escape":
          e.preventDefault(), this.hideListbox();
          break;
        default:
          (s = this.findOption(e.key)) && this.focusOption(s)
      }
    }
    setButtonWidth() {
      let t = t => {
          let e = getComputedStyle(t);
          return parseFloat(e.paddingLeft) + parseFloat(e.paddingRight)
        },
        e = t(this.button),
        s = t(this.selectedOption),
        i = this.button.offsetWidth - this.button.clientWidth,
        n = Math.ceil(this.selectedOption.getBoundingClientRect().width);
      this.button.style.setProperty("--custom-select-button-width", `${n-s+e+i}px`)
    }
    showListbox() {
      this.listbox.hidden = !1, this.listboxOpen = !0, this.classList.add("is-open"), this.button
        .setAttribute("aria-expanded", "true"), this.listbox.setAttribute("aria-hidden", "false"),
        setTimeout(() => {
          this.focusOption(this.selectedOption), this.listbox.focus(), this
            .addListboxOpenListeners()
        })
    }
    hideListbox() {
      this.listboxOpen && (this.listbox.hidden = !0, this.listboxOpen = !1, this.classList.remove(
          "is-open"), this.button.setAttribute("aria-expanded", "false"), this.listbox
        .setAttribute("aria-hidden", "true"), this.focusedOption && (this.focusedOption
          .classList.remove(this.focusedClass), this.focusedOption = null), this.button.focus(),
        this.removeListboxOpenListeners())
    }
    findOption(t) {
      this.searchString += t, this.searchTimer && clearTimeout(this.searchTimer), this
        .searchTimer = setTimeout(() => {
          this.searchString = ""
        }, 500);
      let e = Array.from(this.options).find(t => {
        let e = t.innerText.toLowerCase();
        return e.includes(this.searchString) && !t.classList.contains("is-disabled")
      });
      return e
    }
    focusOption(t) {
      if (this.focusedOption && this.focusedOption.classList.remove(this.focusedClass), this
        .focusedOption = t, this.focusedOption.classList.add(this.focusedClass), this.listbox
        .scrollHeight > this.listbox.clientHeight) {
        let e = this.listbox.clientHeight + this.listbox.scrollTop,
          s = t.offsetTop + t.offsetHeight;
        s > e ? this.listbox.scrollTop = s - this.listbox.clientHeight : t.offsetTop < this
          .listbox.scrollTop && (this.listbox.scrollTop = t.offsetTop)
      }
    }
    selectOption(t) {
      if (t !== this.selectedOption) {
        if (t.setAttribute("aria-selected", "true"), this.selectedOption.setAttribute(
            "aria-selected", "false"), this.swatches && (this.button.dataset.swatch = t.dataset
            .swatch || ""), this.button.firstElementChild.textContent = t.firstElementChild
          .textContent, this.listbox.setAttribute("aria-activedescendant", t.id), this
          .selectedOption = document.getElementById(t.id), this.nativeSelect) this.nativeSelect
          .value = t.dataset.value, this.nativeSelect.dispatchEvent(new Event("change", {
            bubbles: !0
          }));
        else {
          let e = {
            selectedValue: t.dataset.value
          };
          this.dispatchEvent(new CustomEvent("change", {
            bubbles: !0,
            detail: e
          }))
        }
      }
      this.hideListbox()
    }
  }
  customElements.define("custom-select", t)
}
